import { Type } from 'typeserializer';
import { Actor } from './actor';

export class Admin extends Actor {}

export class AdminArray {
  @Type([Admin])
  children: Admin[];
}
